var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": ("find-the-letter " + (_vm.keyboardEnabled ? '' : 'full-height'))
    }
  }, [_c('article', {
    attrs: {
      "slot": "instructions",
      "id": "instructions-container"
    },
    slot: "instructions"
  }, [_c('audio-toggle-button'), _c('h1', {
    staticClass: "find-the-letter-instructions"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.highlightedInstructionsText)
    }
  })])], 1), _c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('section', {
    staticClass: "find-the-letters-container"
  }, _vm._l(_vm.words, function (word) {
    return _c('div', {
      key: word.id,
      staticClass: "letters-to-type-container"
    }, [_c('aside', [_c('img', {
      class: ("image word-" + (word.id)),
      attrs: {
        "alt": word.wordImage.image.description,
        "src": word.wordImage.image.src
      }
    })]), _c('div', {
      staticClass: "letter-container"
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "flex-flow": "row nowrap",
        "justify-content": "flex-start"
      }
    }, [_c('form', [_c('fieldset', {
      staticStyle: {
        "border": "none",
        "display": "flex"
      },
      attrs: {
        "aria-label": word.letters.map(function (letter) {
          return letter.letter;
        }).join('')
      }
    }, [_vm._l(word.letters, function (letter, index) {
      return [_c('div', {
        staticStyle: {
          "align-items": "center",
          "display": "flex",
          "flex-flow": "column"
        }
      }, [_c('label', {
        staticClass: "letter",
        class: letter.classes,
        attrs: {
          "for": ((word.id) + "-" + index + "-" + (letter.letter))
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.letterSelections,
          expression: "letterSelections"
        }],
        attrs: {
          "id": ((word.id) + "-" + index + "-" + (letter.letter)),
          "tabindex": "0",
          "type": "checkbox"
        },
        domProps: {
          "value": ((word.id) + "-" + index + "-" + (letter.letter)),
          "checked": Array.isArray(_vm.letterSelections) ? _vm._i(_vm.letterSelections, ((word.id) + "-" + index + "-" + (letter.letter))) > -1 : _vm.letterSelections
        },
        on: {
          "change": [function ($event) {
            var $$a = _vm.letterSelections,
              $$el = $event.target,
              $$c = $$el.checked ? true : false;
            if (Array.isArray($$a)) {
              var $$v = (word.id) + "-" + index + "-" + (letter.letter),
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.letterSelections = $$a.concat([$$v]));
              } else {
                $$i > -1 && (_vm.letterSelections = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
              }
            } else {
              _vm.letterSelections = $$c;
            }
          }, function ($event) {
            return _vm.handleLetterCheckboxNativeChange(((word.id) + "-" + index + "-" + (letter.letter)), letter);
          }],
          "keyup": function ($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            return _vm.handleLetterCheckboxKeyEnter(((word.id) + "-" + index + "-" + (letter.letter)), letter);
          }
        }
      }), _c('span', {
        class: letter.classes,
        attrs: {
          "id": ((word.id) + "-" + index + "-" + (letter.letter) + "-span")
        }
      }, [_vm._v("\n                          " + _vm._s(letter.letter) + "\n                        ")])])])];
    })], 2)])])])]);
  }), 0)])]), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }